export const en = {
    navigation: {
        profile: "Profile",
        agencies: "Agencies",
        logout: "Logout",
        settings: "Settings",
    },
    admin: {
        globalBranding: "Global Branding",
        settings: "Settings",
    },
    settings: {
        clearAgencies: "Clean Agencies",
        templates: "Templates",
        team: "Team",
        agencies: "Agencies",
        suppliers: "Suppliers",
        options: "Options",
        taxes: "Taxes",
    },
    auth: {
        email: "Email",
        password: "Password",
        passwordRepeat: "Repeat Password",
        passwordSet: "Save Password",
        remember: "Remember me",
        forgot: "Forgot password?",
        login: "Sign In",
        classicLogin: "Sign in with email and password",
        magicLinkLogin: "Sign in with Magic Link",
        requestLink: "Request login link",
        pwUpdated: "Password was successfully set",
        forgotText:
            "Share your email address with us and we will send you a link to reset your password.",
        invalidInvite:
            "This invitation has already been accepted successfully. Click the button to log in. If you have forgotten your password, you can easily reset it.",
        contactConsultant: "Please contact your consultant.",
        forgotPassword: "Forgot Password",
        invalidToken: "Invalid Token",
        contactSupport: "Please contact support.",
        setPassword: "Set Password",
        agencyInviteIntro:
            "Hello {user}, please set your password – then we can get started.",
        agencyInviteIntroNoPassword:
            "Hello {user}, just click the button to join the agency",
        agencyInviteTitle: "Join {agency}",
        apartmentInviteTitle: "Join {project}",
        apartmentInviteIntro:
            "Hello {user}, please set your password – then we can get started.",
        apartmentInviteIntroNoPassword:
            "Hello {user}, just click the button to view the project",
        projectJoined: "Project joined",
        confirmAuthCode:
            "Please confirm access to your account by entering the authentication code provided by your authentication application.",
        confirmAuthRecoveryCode:
            "Please confirm access to your account by entering one of your emergency codes.",
        useRecoveryCode: "Use a recovery code",
        useAnAuthCode: "Use an authentication code",
        resetPassword: "Reset Password",
        setPasswordDesc: "Please set your password.",
        confirmPassword: "Confirm Password",
        resetPasswordDesc:
            "Please confirm your password to activate 2-factor authentication.",
        noPasswordSet: "No password set yet",
        noPasswordSetDesc:
            "You have not yet set a password for this account. Login is therefore only possible via magic link. To change this, you can set a password here.",
        linkSent: "Your link has been sent",
        agencyJoined: "Successfully joined",
        acceptInvite: "Accept Invitation",
        secureArea: "Secure Area",
        secureAreaDescription:
            "This is a secure area of the application. Please confirm your password before continuing.",
    },
    projects: {
        // Auftrag Luca, 2026-08-20 — see the German file for the reasoning.
        // Fix-Runde nach dem ui-validator (K2) — siehe die deutsche Datei.
        feeCalculationMode: "Base fee and consultancy fee calculation:",
        feeCalculationModeLabel: "Base fee and consultancy fee calculation",
        feeCalculationModeExceptionHint: "For exceptional cases only.",
        feeCalculationModeDefaultBadge: "Default",
        feeCalculationModes: {
            offer_based: "Offer based",
            budget_based: "Budget based",
        },
        feeCalculationModeHints: {
            offer_based:
                "The basis is the net sum of the ticked offers of the billed order modifications. The budget plays no part in the calculation.",
            budget_based:
                "Based on the additional costs (costs minus budget, net). The per-offer checkboxes «charge fee» and «charge consultancy fee» no longer apply.",
        },
        feeCalculationModeFinal:
            "This choice applies to the whole project and cannot be changed after creation — it determines every statement retroactively. A later correction is only possible through support.",
        feeCalculationModeCorrect: "Correct the calculation method",
        feeCalculationModeCorrectTitle: "Correct the calculation method of this project?",
        feeCalculationModeCorrectText:
            "Every statement of this project will be recalculated from now on — including completed apartments and exports that have already been sent. Recorded budgets and the per-offer checkboxes stay stored. In budget based mode the “Budget” column cannot be hidden: a budget hidden from buyers becomes visible again there. The correction is logged.",
        feeCalculationModeUpdated: "Calculation method corrected",
        project: "Project",
        projects: "Projects",
        messages: "Messages",
        myProjects: "my projects",
        inactiveProjects: "inactive projects",
        projectDetail: "Project Detail",
        projectNumber: "Project Number",
        projectDescription: "General Project Information",
        newProject: "New Project",
        name: "Name",
        number: "Project Number",
        street: "Street",
        zip: "ZIP",
        city: "City",
        country: "Country",
        image: "Project Image",
        imageDescription: "Photo for the project",
        chooseImage: "Choose Image",
        removeImage: "Remove Image",
        editImage: "Edit Image",
        lead: "Project Lead",
        leadDescription: "Contact details for project lead",
        settings: "Settings",
        presets: "Presets",
        contact: "Contact",
        editContact: "Edit Contact",
        card: "Show Map",
        deadline: "Deadline",
        apartments: "Apartments",
        newApartment: "New Apartment",
        editBase: "Edit Project",
        projectLead: "Project Lead",
        projectAssistance: "Project Support",
        state: "Status",
        stateChange: "Change Status",
        leadChange: "Change Project Lead",
        imageChange: "Change Project Image",
        projectStateDescription:
            "The project status affects the visibility of this project.",
        projectStateChange: "Change Project Status",
        deleteProject: "Delete Project",
        editAssistance: "Change Project Support",
        userId: "User ID",
        persons: "Persons",
        personsDescription: "Employees from your team",
        created: "Project created",
        updated: "Project updated",
        deleted: "Project successfully deleted",
        template: "Template",
        templatePresets: "Project Template",
        templateDescription: "Please select a template to be applied to this project.",
        selectTemplate: "Select Template",
        settingsDescription: "Project-wide parameters",
        consultancyFee: "Construction Management Fee",
        baseFee: "Fee",
        uploadImage: "Upload an image",
        imageRemoved: "Image removed",
        fileInfo: "JPG / PNG (max. {size} MB)",
        fileTooBig: "The file is too large!",
    },
    apartments: {
        projectNameHeader: "Project",
        apartmentSelector: "Apartment",
        apartment: "Apartment",
        overview: "Overview",
        newApartment: "Create New Apartment",
        apartmentDescription: "Apartment information",
        number: "Apartment Number",
        rooms: "Rooms",
        roomsAmount: "Number of Rooms",
        area: "Net Living Area",
        finishedTopics: "Topics Completed",
        pendingApprovals: "Pending Approvals",
        approved: "approved",
        topic: "Topic",
        amountCHF: "Amount CHF",
        remarks: "Remarks",
        checklistTemplate: "Checklist Template",
        currentChecklist: "Current Checklist",
        budget: "Additional/Reduced Cost Statement",
        total: "Total",
        buyers: "Buyers",
        buyerAssistance: "Buyer Support",
        checklist: "Checklist",
        apartmentStateChange: "Change Apartment Status",
        state: "Apartment Status",
        apartmentStateDescription:
            "The apartment status determines whether an apartment can be edited",
        created: "Apartment created",
        updated: "Apartment updated",
        buyerCreated: "Buyer created",
        buyerDeleted: "Buyer removed",
        buyerUpdated: "Buyer updated",
        editBuyer: "Edit Buyer",
        inviteSent: "Invitation sent",
        buyer: "Buyer",
        buyerDescription: "Buyer of the apartment",
        editAssistance: "Change Buyer Support",
        persons: "Buyer Support",
        firstname: "First Name",
        lastname: "Last Name",
        street: "Street",
        zip: "ZIP",
        city: "City",
        country: "Country",
        phone: "Mobile",
        email: "Email",
        notify: "Notify on pending approvals, new messages or other changes",
        inviteNow: "Invite buyer now",
        notInvited: "not invited",
        invite: "Invite",
        addEmail: "Add email",
        inviteNowHint: "Creates an account and sends the invitation right away. Switched off, the buyer is only recorded; you can invite them later from the apartment.",
        inviteNeedsEmail: "Requires an email address.",
        editApartment: "Edit Apartment",
        newBuyer: "New Buyer",
        deleteBuyer: "Delete Buyer",
        confirmDeleteBuyer: "Are you sure you want to delete this buyer?",
        settings: "Settings",
        deleteOffer: "Delete Offer",
        confirmDeleteOffer: "Are you sure you want to delete this offer?",
        // Notes as dated entries (Thema 7,
        // docs/superpowers/specs/2026-08-04-welle1-notizen-eintraege-design.md).
        notes: "Notes",
        notesSubtitle: "Conversations, appointments and decisions about the apartment",
        newNote: "New Entry",
        noteCategory: "Category",
        noteCategories: {
            meeting: "Meeting",
            call: "Phone Call",
            site: "Site Visit",
            email: "Email",
            note: "Note",
        },
        noteMonths: {
            "01": "January",
            "02": "February",
            "03": "March",
            "04": "April",
            "05": "May",
            "06": "June",
            "07": "July",
            "08": "August",
            "09": "September",
            10: "October",
            11: "November",
            12: "December",
        },
        showAllNotes: "Show All",
        noteTitle: "Title",
        noteTitlePlaceholder: "Kitchen Sampling",
        noteDate: "Date",
        noteParticipants: "Participants",
        noteParticipantsPlaceholder:
            "Freida McClure, Michèle von Vacano, R. Bieri (Kitchen Builders Ltd.)",
        noteParticipantsHint:
            "Free text — including externals such as site management or contractors.",
        noteBody: "Note",
        noteBodyPlaceholder: "What was discussed, decided, what is still open?",
        noteCreated: "recorded",
        noteEdited: "edited",
        noteDeleteConfirm: "Delete this entry?",
        noteVisibleForBuyer: "Visible to buyer",
        noteVisibleBadge: "shared with buyer",
        notesBuyerSubtitle: "Notes your advisor has shared with you",
        emptyNotes: "No notes available",
        offeredCHF: "Costs CHF",
        // Auftrag Luca, 2026-08-25 — siehe die deutsche Datei.
        quotedCHF: "Quoted CHF",
        // Auftrag Luca, 2026-08-25, Entscheid 4.1: Kopf der Total-Spalte.
        // BEWUSST EIN EIGENER SCHLUESSEL neben `apartments.total`, obwohl
        // beide heute dasselbe Wort tragen (Nitpick des code-reviewers,
        // 2026-08-25, geprueft und beibehalten): `apartments.total`
        // beschriftet die Summe der offenen Freigaben
        // (`ApartmentsPendingApprovalsItems.vue`), dieser hier den Kopf einer
        // Tabellenspalte. Ein gemeinsamer Schluessel hiesse, dass keiner der
        // beiden Texte mehr geaendert werden kann, ohne den anderen
        // mitzunehmen.
        totalColumn: "Total",
        // Nacharbeit UI-2 (2026-08-25): die Schlusszeile der
        // Exkl.-Ansicht. Ohne sie stuende nirgends, was der Kaeufer
        // tatsaechlich ueberweist.
        totalInclVat: "Total incl. VAT",
        budgetCHF: "Budget CHF",
        difference: "Additional Costs",
        emptyNote: "No note available",
        offered: "offered",
        priceInclVat: "All prices include VAT",
        personsDescription: "Buyer support for this apartment",
        settingsDescription: "Apartment-wide parameters",
        // B-1 (UI-Gate Welle 2, welle2-ui-report.md): shortened counterpart
        // to the German "Honorar" rename, table column header only. See de.js
        // for the full rationale; `projects.consultancyFee` (settings label)
        // stays "Construction Management Fee".
        consultancyFee: "Honorarium",
        baseFee: "Fee",
        subtotal: "Subtotal",
        inclVat: "incl. VAT",
        // Themen 2-4 (Spec docs/superpowers/specs/2026-08-04-welle2-tabelle-detailebene-design.md):
        // VAT toggle + detail level of the billing table.
        exclVat: "excl. VAT",
        taxInclLabel: "of which VAT",
        taxExclLabel: "plus VAT",
        expandAll: "Expand all",
        collapseAll: "Collapse all",
        separatorDeclined: "— DECLINED —",
        separatorUnbilled: "— NOT CONSIDERED —",
        floor: "Floor",
        parking: "Parking",
        parkingPlaceholder: "e.g. 14, 15",
        includedInPurchasePrice: "Budget included in purchase price:",
        reminderSent: "Reminder sent",
        lastReminded: "Last reminded:",
        buyerNotificationsNotActive: "Notifications are not enabled for any buyer!",
        buyerNotificationsNotInvited:
            "The buyers to be notified have not been invited yet!",
        resend: "Invite again",
        inviteAccepted: "Invitation accepted",
        inviteNotAccepted: "Invitation not accepted",
        deleteApartmentTitle: "Confirm Delete Apartment",
        deleteApartmentDesc:
            "Should this apartment really be deleted? Note: Deletion is only possible if there are no more order modifications.",
        deleted: "Apartment was deleted",
        communication: "Communication",
        specifications: "Specifications",
    },
    // Gebaeude-Gruppierung (Themen 15-18): die englische Fassung wurde beim
    // Bauen nachgezogen, weil der UI-Anteil dieses Pakets direkt uebernommen
    // wird — hartkodierte oder nur deutsche Texte landen sonst unveraendert
    // in der Anwendung.
    buildings: {
        unassigned: "Not yet assigned",
        expandAll: "Expand all",
        collapseAll: "Collapse all",
        menu: "Menu",
        rename: "Rename",
        moveUp: "Move up",
        moveDown: "Move down",
        delete: "Delete",
        deleteTitle: "Delete building",
        apartment: "Apartment",
        apartments: "Apartments",
        emptyHint:
            "Empty — drag an apartment here or assign it via \u201cMove to…\u201d.",
        dragToMove: "Drag to move",
        nudgeOne:
            "1 apartment is not assigned to a building yet — assign it via the \u22ef menu or drag it by the handle.",
        nudgeMany:
            "{count} apartments are not assigned to a building yet — assign them via the \u22ef menu or drag them by the handle.",
        building: "Building",
        choose: "Select building",
        levelNames: "Name levels",
        levelNamesTitle: "Levels of this project",
        levelNamesIntro:
            "What are the levels called in this project? These names appear in the add menu and later as column headings in the exports. Leave empty to keep the default.",
        level: "Level {number}",
        addNamed: "Add {level}",
        nameOf: "Name of level \u201c{level}\u201d",
        moveTo: "Move to…",
        moveTitle: "Move",
        moveIntro: "Where should \u201c{name}\u201d be moved to?",
        rootLevel: "Top level",
        moveCurrent: "current location",
        moveOwnSubtree: "own subgroup",
        moveTooDeep: "too deep",
        depthReached:
            "No further level is possible here — at most {max} are allowed.",
        deleteConfirm: "Really delete \u201c{name}\u201d?",
        deleteConfirmWithApartments:
            "Really delete \u201c{name}\u201d? The {count} assigned apartments move to \u201cNot yet assigned\u201d.",
    },
    // Thema 1 (Spec docs/superpowers/specs/2026-08-04-welle2-spalten-sichtbarkeit-design.md):
    // column visibility internal/buyer — project modal, apartment modal and
    // the two entry points (ProjectsInfobar, ApartmentsBudget).
    columns: {
        title: "Column Visibility",
        manage: "Manage Columns",
        internal: "Internal",
        buyer: "Buyer",
        useDefault: "Use Project Default",
        projectDescription:
            "Determines which columns apartments in this project show by default.",
        apartmentDescription:
            "Determines which columns are shown for this apartment. Without a selection of its own, the project default applies.",
        // Auftrag 2026-08-16, Entscheid 15: die Begründung nennt den
        // Berechnungsmodus bewusst NICHT.
        notHideable: "cannot be hidden for this agency",
    },
    // Wave 3, topic 6 (Spec docs/superpowers/specs/2026-08-04-welle3-thema6-exportmenue-design.md):
    // project page export menu (trigger + two XLSX downloads).
    exports: {
        menu: "Export",
        deadlines: "Open Deadlines",
        buyers: "Buyer List",
        // Wave 3, topic 5 (Spec
        // docs/superpowers/specs/2026-08-04-welle3-thema5-excel-abrechnung-design.md):
        // billing export — apartment action bar (`ApartmentsBudget`) and third
        // entry in the project export dropdown (`ProjectsInfobar`, collective).
        budget: "Billing",
        // Wave 3, topic 12 (Spec
        // docs/superpowers/specs/2026-08-04-welle3-thema12-archiv-zip-design.md):
        // fourth entry — opens a selection modal instead of downloading directly.
        archive: "Archive",
        archiveTitle: "Export archive",
        archiveDescription:
            "Choose the apartments to download as a ZIP — billing and documents per apartment, notes and chat history optional.",
        archiveSelectAll: "Select all",
        archiveDeselectAll: "Deselect all",
        archiveWithNotes: "Include notes",
        archiveWithChat: "Include chat history",
        archiveNoSelection: "Select at least one apartment.",
        bkp: "Costs by BKP",
        bkpTitle: "Costs by BKP",
        bkpDescription:
            "Cost matrix by construction cost plan. Rows are the BKP positions, columns the buildings and apartments. One sheet per building.",
        bkpDescriptionNoBuildings:
            "Cost matrix by construction cost plan. Rows are the BKP positions, columns the apartments.",
        bkpWithUnassigned: "Include apartments without a building",
        bkpDisplay: "Display",
        bkpSubgroupSheets: "Subgroups as separate sheets",
        bkpSheetCount: "{count} sheets in the file",
        bkpHideEmpty: "Hide empty BKP positions",
        bkpAmounts: "Amounts",
        bkpGross: "Including VAT (gross)",
        bkpNet: "Excluding VAT (net)",
        bkpOnlyBilled: "Billed order modifications only",
        bkpWithFees: "Include fee and site management fee",
        bkpApartmentCount: "{count} apt.",
        bkpNoSelection: "Select at least one building.",
    },
    suppliers: {
        suppliers: "Suppliers",
        supplier: "Supplier",
        supplierDetail: "Supplier Detail",
        newSupplier: "Create New Supplier",
        inactiveSuppliers: "inactive suppliers",
        name: "Name",
        website: "Website",
        street: "Street",
        zip: "ZIP",
        city: "City",
        country: "Country",
        firstname: "First Name",
        lastname: "Last Name",
        email: "Email",
        mobile: "Mobile",
        address: "Address",
        addressDescription: "Supplier address",
        contact: "Contact",
        contactDescription: "Responsible contact person at the supplier",
        editBase: "Edit Supplier",
        editContact: "Edit Contact",
        stateChange: "Change Status",
        state: "Status",
        stateDescription: "Change supplier status",
        apartment: "Apartment",
        topic: "Topic",
        projects: "Projects",
        created: "Supplier created",
        updated: "Supplier updated",
        offers: "Offers",
        noSupplier: "without supplier",
        stateActiveTitle: "Active",
        stateActiveDescription: "This supplier is available in the supplier selection.",
        stateInactiveTitle: "Inactive",
        stateInactiveDescription: "This supplier is hidden from the supplier selection.",
        // Thema 9 (Welle 4, Paket c) — company data (email/phone) + contact persons.
        phone: "Phone",
        companyContact: "Company Contact",
        companyContactDescription:
            "General contact details of the company (email, phone)",
        contacts: "Contact Persons",
        contactsDescription: "Contact persons of this supplier",
        contactPerson: "Contact Person",
        noContactSelected: "No contact person selected",
        noContactsYet: "No contact persons recorded yet.",
        addSupplier: "Add supplier",
        supplierOptional: "optional",
        chooseCountry: "Choose country…",
        addContact: "Add contact person",
        newContact: "New contact person",
        // Own key for the SELECT PLACEHOLDER — see the German catalogue.
        noContactsYetShort: "No contact persons yet",
        removeContact: "Remove contact person",
        contactFallbackNotice: "Company contact (no direct contact on file)",
        // ANFORDERUNGEN-V2 V2-09: label and link inside the supplier block of
        // the topic header. OWN key — `contactPerson` already exists above and
        // labels four forms; a second entry of the same name would have
        // silently overridden them.
        contactPersonHeading: "Contact person",
        openAllDetails: "Open all details →",
        contactCreated: "Contact person created",
    },
    topics: {
        active: "Active",
        name: "Name",
        budget: "Budget",
        editBudget: "Edit Budget",
        budgetDescription: "Budget for this topic",
        deadline: "Deadline",
        editDeadline: "Edit Deadline",
        deadlineDescription: "Latest date for acceptance of the offer by the customer.",
        supplier: "Supplier",
        editSupplier: "Edit Supplier",
        supplierDescription: "Supplier for this topic",
        comment: "Remark",
        note: "Note",
        noteText:
            "Changes to the topics below apply to all new apartments. After saving, they can be applied to existing apartments.",
        templates: "Templates",
        info: "Information",
        plandata: "Plan Data",
        offer: "Offer",
        offerDescription: "Offer details",
        offers: "Offers",
        offered: "Offered",
        date: "Date",
        difference: "Additional Costs",
        inclVat: "Prices include VAT.",
        documents: "Documents",
        version: "Version",
        state: "Status",
        viewFileHistory: "Version History",
        fileHistory: "Versions",
        fileHistoryDescription: "Different versions of this file",
        updated: "Topic updated",
        stateChange: "Change Status",
        topicsStateChange: "Change Topic Status",
        topicsStateDescription: "Adjust status for this topic",
        emptyInfo: "No information text available.",
        emptyOffers: "No offer recorded yet.",
        emptySupplier: "without supplier",
        emptyBudget: "No budget set yet.",
        emptyDeadline: "No deadline defined.",
        emptyDocuments: "No documents available.",
        editDescription: "Edit Topic Description",
        description: "Description",
        offerTitle: "Title",
        editInclusiveBudget: "Edit Inclusive Budget",
        inclusive_budget: "Inclusive Budget",
        inclusive_reference: "Reference Value",
        inclusive_unit: "Unit",
        inclusiveBudget: "Inclusive Budget",
        // Auftrag 2026-08-16, Entscheid 13: Leerfall des Themenkopfs, wenn die
        // Budget-Funktion ausgeblendet ist.
        withoutInclusiveBudget: "without inclusive budget",
        inclusiveBudgetDescription:
            "The inclusive budget includes services included in the purchase price. Specifying a reference value and unit is only necessary if a price per unit is to be shown (Example: Inclusive budget CHF 5000, reference value 100, unit m2 => CHF 50.00 / m2)",
        includedInPurchasePrice: "Included in purchase price:",
        icon: "Icon",
        noTopic: "No topic created yet",
        noTopicDesc: "Please click add to insert a topic.",
        editIcon: "Change Topic Icon",
        bkp: "BKP",
        disable_calculation: "Disable fee calculation",
        orderModification: "Order Modification",
        orderModificationDescription: "Order modification details",
    },
    orderModifications: {
        new: "New Order Modification",
        title: "Title",
        comment: "Description",
        description: "Description",
        orderModification: "Order Modification",
        orderModifications: "Order Modifications",
        state: "Status",
        emptyOrderModifications: "No order modifications available",
        vatInfo: "Prices include statutory VAT",
        cost: "Cost",
        // Auftrag Luca, 2026-08-25, Entscheid 1.1: dieselbe Spalte im
        // budgetbasierten Modus.
        quoted: "Quoted",
        showDetails: "Show Details",
        created: "created",
        update: "Edit Order Modification",
        budget: "Budget",
        difference: "Difference",
        approval: "Approval",
        approvalInfo: "Binding approval of this order modification by the customer",
        approve: "Approve Order Modification",
        decline: "Decline Order Modification",
        declinedMessage: "Order modification declined",
        declinedReason: "Reason:",
        orderModificationNotSent: "Order modification not yet sent!",
        orderModificationNotSentDesc:
            "Please press the send button to submit the order modification to the buyers for approval.",
        orderModificationDecision: "Please approve the order modification",
        orderModificationDecisionDesc:
            "Please review all offers carefully and approve the order modification (all offers) or reject it with a reason. By approving the order modification you give us a binding order to execute the offers listed in this order modification.",
        orderModificationApproved: "Order modification approved",
        orderModificationApprovedDesc:
            "The order modification has been approved for execution",
        send: "Send Order Modification",
        by: "by",
        at: "on",
        oclock: "",
        backTo: "Back to",
        deleteOrderModificationTitle: "Confirm Delete Order Modification",
        deleteOrderModificationDesc:
            "Should this order modification including all offers and approvals be deleted? This step cannot be undone!",
        deleted: "Order modification deleted",
        updated: "Order modification updated",
        pendingSignatures: {
            title: "Signatures pending",
            boxDescription:
                "Some offers in this change require digital signatures. All buyers must sign before this change can be approved.",
            showAdvisor: "Show reminders and resend",
            showBuyer: "Show pending signatures",
            modalTitle: "Buyers' pending signatures",
            introAdvisor:
                "The following buyers have not yet signed the offer documents. Please make sure all signatures are in place before approval.",
            introBuyer:
                "The following signatures are still pending. The change can only be approved once all buyers have signed.",
            colOffer: "Offer",
            colBuyer: "Buyer",
            colAction: "Action",
            rejected: "Declined",
            sending: "Sending...",
            resendEmail: "Resend email",
            signNow: "Sign now",
            signNowFor: "Sign for {name}",
            approvalBlocked: "Approval blocked until all buyers have signed.",
            signDocument: "Sign document",
            signingDone: "Signing completed",
            signHint:
                'Click the green "Done" or "Finish" button in the signing window once you are finished.',
            signatureProcessed: "Signature processed.",
            reminderSent: "Reminder email sent.",
            reminderFailed: "The email could not be resent.",
            genericError: "Something went wrong.",
        },
        confirmApprove: {
            title: "Confirm binding approval",
            question: "Are you sure you want to approve this offer?",
            description:
                "By approving, you confirm the offer as binding. The offer can no longer be edited or withdrawn afterwards.",
            confirm: "Approve as binding",
        },
        states: {
            created: "Created",
            readyForApproval: "Decision",
            approved: "Approved",
            declined: "Declined",
            replaced: "Replaced",
        },
    },
    offers: {
        title: "Title",
        customBkp: "Other BKP",
        number: "Offer No.",
        cost: "Amount excl. VAT",
        type: {
            label: "Type",
            offer: "Offer",
            credit: "Credit note",
            creditHint: "Booked as a negative amount (−CHF).",
        },
        applyBaseFee: "Apply base fee to this offer",
        applyConsultancyFee: "Apply consultancy fee to this offer",
        // K-3 (UI-Gate Welle 2, welle2-ui-report.md): shared group label for
        // the two fee checkboxes above.
        feeFlagsLabel: "Billing",
        comment: "Remark",
        created: "Offer was created",
        updated: "Offer was updated",
        replaced: "New offer created",
        deleted: "Offer was deleted",
        file: "Offer",
        fileInfo: "PDF / ZIP (max. {size} MB)",
        fileTooBig: "The file is too large!",
        // See the German catalogue.
        fileInfoSigned: "PDF (max. {size} MB — offers to be signed)",
        signedFileTooBig: "Offers to be signed: max. {size} MB.",
        fileTypeInvalid: "This file type is not supported.",
        // Fix Welle 4.5 UI-Gate (welle45-ui-report.md, blocking finding):
        // replaces the formerly hardcoded English string
        // "Digital signature requires PDF.".
        digitalSignatureRequiresPdf: "Digital signature is only possible for PDF files.",
        digitalSignatureRequired: "Digital signature required?",
        replace: "Replace Existing Offer",
        new: "Add Offer",
        edit: "Edit Offer",
        supplier: "Supplier",
        declineOffer: "Decline Offer",
        bkps: "BKP Number",
        date: "Date",
        state: {
            created: "Created",
            readyForApproval: "Decision",
            approved: "Approved",
            declined: "Declined",
            replaced: "Replaced",
        },
        decline: "Decline Offer",
        declineDescription: "Do not accept offer",
        declineOfferConfirm: "Do you really want to decline this offer?",
        reason: "Reason",
        showComment: "Show Comment",
        offerNotSent: "Offer not yet sent",
        offerNotSentDesc:
            "Please press the send button to submit the offer to the buyers.",
        offerNotApproved: "Offer not approved",
        offerNotApprovedDesc: "Please review the submitted offer and approve it.",
        description: "Title",
        bkpTitle: "BKP",
        actions: "Actions",
        version: "Version",
        totalWithTax: "Total incl. VAT",
        totalWithoutTax: "Total excl. VAT",
        taxAmount: "VAT",
        taxRate: "VAT Rate",
        netCost: "Amount excl. VAT",
        vatInfo: "The VAT is based on the rate applicable at the time of service.",
        bkp: {
            N211: "211 Shell Construction",
            N215_5: "215.5 Facade Cladding",
            N221: "221 Windows",
            N221_8: "221.8 Balcony Glazing",
            N224_1: "224.1 Flat Roof / Sealing",
            N224_3: "224.3 Glass Installations in Flat Roofs",
            N228_1: "228.1 Sun Protection",
            N228_5: "228.5 Insect Protection",
            N230: "230 Electrical",
            N240: "240 Heating",
            N244: "244 Ventilation",
            N250: "250 Plumbing",
            N252: "252 Washing Machine + Dryer",
            N258: "258 Kitchen",
            N271_0: "271.0 Plasterer Rendering",
            N271_1: "271.1 Plasterer Drywall",
            N273_0: "273.0 Interior Doors",
            N273_1: "273.1 Built-in Wardrobes",
            N273_3: "273.3 General Carpentry",
            N274: "274 Metal Construction and Glazing",
            N275: "275 Locking System",
            N281_0: "281.0 Floor Screeds",
            N281_4: "281.4 Natural Stone Flooring",
            N281_6: "281.6 Tile Flooring",
            N281_7: "281.7 Wood Flooring",
            N282_4: "282.4 Natural Stone Wall Cladding",
            N282_6: "282.6 Tile Wall Cladding",
            N284: "284 Fireplace / Stove",
            N285: "285 Painting",
            N288: "288 Landscaping Building",
            N291_0: "291.0 Architect",
            N291_1: "291.1 Construction Management",
            N291_2: "291.2 Buyer Request Fees",
            N292: "292 Civil Engineer",
            N293: "293 Electrical Engineer",
            N294: "294 HVAC Engineer",
            N297_3: "297.3 Building Physicist",
            N298_5: "298.5 Fire Safety Engineer",
            N299: "299 Buyer Support",
            N421: "421 Landscaping Surroundings",
            N810: "810 Architect Fees",
            N820: "820 Structural Engineer Fees",
            N830: "830 Electrical Engineer Fees",
            N840: "840 HVAC Engineer Fees",
            N850: "850 Plumbing Engineer Fees",
            none: "none",
            other: "other BKP",
        },
        priceCalc: {
            addButton: "Add Price Calculation",
            editButton: "Edit Price Calculation",
            viewTitle: "View Price Calculation",
            unit: "Unit",
            pricePerUnit: "Price per Unit",
            amount: "Amount",
            total: "Total exkl. MwSt",
            selectUnit: "Select unit",
            errorUnit: "Unit is required.",
            errorPricePerUnit: "Price per unit is required.",
            errorAmount: "Amount is required.",
            errorCostZero: "Amount must be at least 0.",
            errorMismatch: "Amount excluding VAT does not match Price Calculation total.",
            rowCount: "({count} items)",
        },
    },
    documents: {
        title: "Documents",
        file: "File",
        comment: "Remark",
        document: "Document",
        documentDescription: "Documents for the buyers",
        fileInfo: "{extensions} (max. {size} MB)",
        fileTooBig: "The file is too large!",
        fileTypeInvalid: "This file type is not supported.",
        // The toast truncates at 100 characters: name the limit briefly.
        signedFileTooBig: "Documents to be signed: max. {size} MB.",
        name: "Name",
        version: "Version",
        date: "Date",
        emptyDocuments: "No documents available",
        new: "Create Document",
        created: "Document created",
        updated: "Document updated",
        deleted: "Document deleted",
        showComment: "Show Comment",
        edit: "Edit Document",
        deleteDocument: "Delete Document",
        confirmDeleteDocument: "Do you really want to delete this document?",
        replace: "Replace Document",
        sign: "Sign Document",
        finishedSigning: "I have finished signing",
        clickGreenButton: "Please click the green button when done.",
        downloadingForSigning: "Downloading latest document version for signing...",
        errorCouldNotStartSelfSign: "Could not start self sign.",
        errorCheckingStatus: "Error checking status.",
        errorCompleteSignatureFirst: "Please complete your signature first.",
        errorSelectBuyer: "Select at least one buyer.",
        errorAssignBoxToBuyer: "Assign each box to a buyer.",
        errorSendingDocument: "Error sending document.",
        errorLimitReached: "Limit Reached",
        errorTooManyBuyers: "You can only select up to :max buyers.",
        errorNotAllowed: "Not Allowed",
        errorBuyerNotInvited:
            "This buyer has not been invited yet and cannot be selected as a signer.",
        buyerNotInvitedBadge: "Not invited yet",
        uninvitedBuyersHidden:
            "Buyers who have not been invited do not appear here — nothing goes out before the invitation.",
        errorSelfSignCompleted: "Self sign already completed. Cannot copy self boxes.",
        digitalSignature: "Digital Signature",
        // Wave 4, topic 8: distribute documents from the project level to
        // several apartments.
        distribute: "Distribute Documents",
        distributeTitle: "Distribute Documents",
        distributeDescription:
            "Upload a document and distribute it to several apartments — either directly to the overview or to a topic matched by name.",
        distributeTarget: "Target",
        distributeTargetOverview: "Overview (directly on the apartment)",
        distributeTargetTopic: "Topic (matched by name)",
        distributeTopicName: "Topic",
        distributeTopicPlaceholder: "Select a topic",
        distributeApartments: "Apartments",
        distributeScopeAll: "All ({count})",
        distributeScopeSelection: "Selection",
        distributeSummary:
            "Will be distributed to {count} apartment(s) — target: {target}.",
        distributeNotify: "Notify buyers",
        distributeSubmit: "Distribute",
        distributeResultSummary: "{distributed} of {total} apartments delivered",
        distributeSkipped: "Skipped",
        distributeSkipReasons: {
            noMatchingTopic: "No active topic with this name",
            error: "Error while distributing",
            notFound: "Apartment not found",
        },
    },
    contact: {
        company: "Company",
        firstname: "First Name",
        lastname: "Last Name",
        email: "Email",
        mobile: "Mobile",
    },
    templates: {
        title: "Templates",
        newTemplate: "Create New Template",
        copyTemplate: "Copy Template",
        renameTemplate: "Rename Template",
        name: "Name",
        template: "Template",
        templateDescription: "Template name",
        topics: "Topics",
        editTitle: "Edit Template",
        created: "Template created",
        updated: "Template updated",
        deleted: "Template deleted",
        deleteTemplate: "Delete Template",
        markedDefault: "Template set as default",
    },
    actions: {
        save: "Save",
        saved: "Saved",
        delete: "Delete",
        back: "Back",
        update: "Update",
        add: "Add",
        cancel: "Cancel",
        remind: "Remind",
        upload: "Upload",
        edit: "Edit",
        seeMore: "See more",
        reset: "Reset",
        success: "Success!",
        error: "Error",
        defaultError: "Action could not be performed",
        decline: "Decline",
        chooseFile: "Choose File",
        removeFile: "Remove File",
        close: "Close",
        enable: "Enable",
        disable: "Disable",
        done: "Done",
        select: "Select",
        remove: "Remove",
        revoke: "Revoke",
        notAvailable: "Not available",
        added: "Added",
        apply: "Apply",
        copy: "Copy",
        download: "Download",
        view: "View",
        open: "Open",
        yes: "Yes",
        no: "No",
        saving: "Saving...",
        leave: "Leave",
        notSavedChanges: "Unsaved Changes",
        notSavedChangesDesc: "Please press save to apply the changes.",
        leaveTitle: "Leave without saving?",
        leaveText:
            "Your changes to the topics have not been saved yet. If you leave the page, they will be lost.",
        leaveWithoutSaving: "Leave without saving",
        keepEditing: "Keep editing",
        saveFirst: "Save first",
        confirm: "Confirm",
        next: "Next",
        previous: "Previous",
    },
    forms: {
        optional: "Optional",
        selectCountry: "Select country...",
        dropFileHint: "Drag a file here or select one above",
        dropFileActive: "Drop file here",
    },
    dialogs: {
        deleteProject: "Do you want to permanently delete this project?",
        deleteTemplate: "Do you want to permanently delete this template?",
        somethingWentWrong: "Whoops! Something went wrong!",
        sendFeedback: "Send Feedback",
    },
    states: {
        open: "open",
        in_process: "in progress",
        blocked: "blocked",
        completed: "completed",
        active: "active",
        inactive: "inactive",
        archived: "archived",
    },
    agencies: {
        clearTitle: "Clean Agencies",
        search: "Search",
        deleteSelected: "Delete Selected",
        confirmDeleteSelected: "Do you really want to delete the selected agencies?",
        title: "Agencies",
        edit: "Edit",
        updated: "Agency was updated",
        name: "Company",
        ownerFirstname: "First Name",
        ownerLastname: "Last Name",
        ownerEmail: "Email",
        ownerMobile: "Mobile",
        inviteSent: "Invitation successfully sent",
        inviteDeleted: "Invitation successfully deleted",
        roleUpdated: "Role was updated",
        advisorRemoved: "Member successfully removed",
        newAgency: "Create New Agency",
        created: "Agency successfully created",
        saveAndInvite: "Save & Invite",
        agency: "Agency",
        agencyDescription:
            "An agency consists of a team that independently supports buyers.",
        editAgency: "Edit Agency",
        addTeamMember: "Add Member",
        inviteMember: "Invite Member",
        teamMembers: "Team Members",
        teamMembersDescription: "These people are members of the agency team.",
        pendingTeamInvitations: "Pending Team Invitations",
        pendingTeamInvitationsDesc:
            "These people have been invited to your team and received an invitation email. They can join the team by accepting the email invitation.",
        member: "Member",
        memberDescription: "Invite a new team member to collaborate in the agency.",
        firstname: "First Name",
        lastname: "Last Name",
        email: "Email",
        role: "Role",
        mobile: "Mobile",
        leaveTeam: "Leave Team",
        confirmLeaveTeam: "Are you sure you want to leave this team?",
        removeTeamMember: "Remove Team Member",
        confirmRemoveTeamMember:
            "Are you sure you want to remove this person from the team?",
        manageRole: "Manage Role",
        // Auftrag 2026-08-16, Entscheide 5 und 6: nur der Superadmin sieht
        // diesen Block. Der Bestätigungstext nennt die Folge beim Namen.
        feeCalculationMode: "Base fee and consultancy fee calculation",
        // Auftrag Luca, 2026-08-20, Entscheid 4 — see the German file.
        feeCalculationModeDescription:
            "Sets the default that NEWLY created projects of this agency use to calculate the base fee and the consultancy fee. Existing projects are not affected — the calculation method is chosen when a project is created and shown on its detail page.",
        feeCalculationModeDefaultBadge: "Default",
        feeCalculationModeExceptionHint: "For exceptional cases only.",
        feeCalculationModes: {
            offer_based: "Offer based",
            budget_based: "Budget based",
        },
        feeCalculationModeHints: {
            offer_based:
                "The basis is the net sum of the ticked offers of the billed order modifications. The budget plays no part in the calculation.",
            // Fix-Runde nach dem ui-validator (K3) — see the German file: the
            // basis has been NET since the conversion on 2026-08-18.
            budget_based:
                "The basis is the excess cost (cost minus budget, net). The per-offer checkboxes “charge base fee” and “charge consultancy fee” are gone.",
        },
        feeCalculationModeConfirmTitle: "Really switch the calculation method?",
        feeCalculationModeConfirmText:
            "Every statement of this agency will be recalculated from now on — including completed apartments and exports that have already been sent. Recorded budgets and the per-offer checkboxes stay stored. In budget based mode the “Budget” column cannot be hidden: a budget hidden from buyers becomes visible again there.",
        feeCalculationModeUpdated: "Calculation method switched",
        switchAgency: "Switch to Agency",
        active: "active",
        inactive: "inactive",
        activateAgency: "Activate Agency",
        deactivateAgency: "Deactivate Agency",
        deactivateAgencyInfo:
            "After deactivating, this agency cannot be used further unless reactivated. Please consider the following points:",
        deactivateAgencyInfoPoint1:
            "Users who only have this agency will no longer be able to use the app. Buyer advisors assigned only to this agency will no longer be able to use IMMIVO.",
        deactivateAgencyInfoPoint2:
            "Buyer advisors assigned to other agencies must select them at the next login.",
        deactivateAgencyInfoPoint3: "Buyers still have access to their properties.",
        deactivated: "Agency deactivated",
        activate: "Activate Agency",
        activated: "Agency activated",
        activateInfo: "Do you want to reactivate this agency?",
        deleteAgency: "Delete Agency",
        noAgency: "No Agency",
        noAgencyInfo:
            "No agency is assigned to your user. <br /> If this is an error, please contact the administration.",
        joinAgency: "Join Agency",
        joinAgencyInfo: "Please select an agency:",
        deactivateDeleteAgency: "Deactivate / Delete Agency",
        deactivateDeleteAgencyDesc:
            "Deactivating blocks access to this agency's projects without deleting them.",
        deleteAgencyConfirmTitle: "Confirm Delete Agency",
        deleteAgencyConfirmDesc:
            "By confirming this action, both the agency and agency users will be deleted. This step cannot be undone. If in doubt, it is recommended to deactivate the agency.",
        affectedUsers: "The following user accounts will also be deleted:",
        deleted: "Agency deleted",
        branding: "Branding",
        brandingSettings: "Branding Settings",
        logo: "Logo",
        navbarColor: "Navbar Color",
        sidebarColor: "Sidebar Color",
        navbarTextColor: "Navbar Text Color",
        sidebarTextColor: "Sidebar Text Color",
        emailBackgroundColor: "Email Background Color",
        publish: "Publish",
        resetToDefault: "Reset to Default",
        preview: "Preview",
        resendInvitation: "Send Invitation",
        sendingInvitation: "Sending...",
        invitationSent: "Sent!",
        invitationResent: "Invitation successfully sent",
        primaryOwner: "Primary Owner",
        makeSomeoneElsePrimaryOwner:
            "Make someone else primary owner before you leave agency.",
        transferPrimaryOwnership: "Transfer Primary Ownership",
        transferPrimaryOwnershipDesc:
            "Please select a new primary owner from the list below before you leave the agency.",
    },
    options: {
        option: "Option",
        optionDescription: "Selection option for customers",
        options: "Options",
        optionSets: "Option Sets",
        name: "Internal Name",
        description: "Description",
        title: "Title",
        inactiveOptions: "Show inactive",
        set: "Set",
        setDescription:
            "A set is a collection of options presented to the customer for pre-selection.",
        newSet: "New Set",
        assignSet: "Assign Set",
        newOption: "New Option",
        editOption: "Edit Option",
        deleteOption: "Delete Option",
        updated: "Option updated",
        deleted: "Option deleted",
        orderUpdated: "Order updated",
        setUpdated: "Set updated",
        created: "Set successfully created",
        cost: "Cost Information",
        infotext: "Info Text",
        infoimages: "Info Images",
        images: "Images",
        price: "Price",
        optionName: "Name",
        state: "Status",
        stateChange: "Change Status",
        preselected: "Pre-selection",
        optionSetState: "Option Set Status",
        changeOrder: "Change Order",
        unit: "Unit",
        optionSetStateDescr:
            "The option set status determines whether the set can be assigned to topics.",
        optionInfoText:
            "This option is already in use. An update will apply the data to all options in use. If the option is deactivated, it can no longer be selected.",
        galleryTitle: "Sample Gallery",
        warningInUse: "This option cannot be deleted as it is still in use!",
        confirmDelete: "Do you really want to delete this option?",
        editImages: "Manage Images",
        imageAdded: "Image added",
        imageRemoved: "Image deleted",
        addImage: "Upload Image",
        imageMadeDefault: "Image set as default",
        fileTooBig: "The file is too large!",
        previewImage: "Preview Image",
        asPreviewImage: "As Preview Image",
        of3ImagesUploaded: "of 3 images uploaded",
        noImageUploaded: "...no image uploaded yet",
        maxFilesize: "JPG / PNG (max. {size} MB)",
        infoimagesText:
            "Informative images and graphics can be stored here. For example images of laying directions for parquet floors.",
        setDeleted: "Set deleted",
        internal_note: "Internal Note",
        setDelete: "Delete Option Set",
        setDeleteConfirm: "Do you really want to delete the option set?",
        showInfo: "Show Information",
    },
    set: {
        set: "Set",
        setDescription: "Properties of this set",
        name: "Name",
        title: "Title",
        description: "Description",
        internal_note: "Internal Note",
        external: "External",
        options: "Options",
        option: "Option",
    },
    profile: {
        profile: "Profile",
        profileInformation: "Profile Information",
        profileInformationInfo:
            "Update your account's profile information and email address.",
        twoFactorAuthActivated: "2-Factor Login activated",
        photo: "Photo",
        selectNewPhoto: "Select A New Photo",
        removePhoto: "Remove Photo",
        cropPhoto: "Crop Your Profile Photo",
        crop: "Crop",
        cropInstructions:
            "Drag and resize the square to select the area you want to keep.",
        firstname: "First Name",
        lastname: "Last Name",
        email: "Email",
        mobile: "Mobile",
        passwordRefresh: "Update Password",
        passwordInfo:
            "Make sure your account uses a long, random password to stay secure.",
        passwordCurrent: "Current Password",
        passwordNew: "New Password",
        passwordConfirm: "Confirm Password",
        twoFactorAuth: "Two-Factor Authentication",
        twoFactorAuthInfo:
            "Add additional security to your account using two-factor authentication.",
        twoFactorAuthDeactivated: "You have not enabled two-factor authentication.",
        twoFactorAuthInfoText:
            "When two-factor authentication is enabled, you will be prompted for a secure, random token during authentication. You can retrieve this token from your phone's Google Authenticator application.",
        browserSessions: "Browser Sessions",
        browserSessionsInfo:
            "Manage and log out your active sessions on other browsers and devices.",
        browserSessionsText:
            "If necessary, you can log out of all other browser sessions on all your devices. Some of your recent sessions are listed below; however, this list may not be complete. If you believe your account has been compromised, you should also update your password.",
        browserSessionsLogOut: "Log Out Other Browser Sessions",
        browserSessionsEnterPw:
            "Please enter your password to confirm that you wish to log out of all other browser sessions.",
        deleteAccount: "Delete Account",
        deleteAccountInfo: "Permanently delete account",
        deleteAccountText:
            "Once your account is deleted, all of its resources and data will be permanently deleted. Before deleting your account, please download any data or information that you wish to retain.",
        deleteAccountConfirm:
            "Are you sure you want to delete your account? Once your account is deleted, all of its resources and data will be permanently deleted. Please enter your password to confirm you would like to permanently delete your account.",
        twoFactorEnableInfoText:
            "Two-factor authentication is now enabled. Scan the following QR code using your phone's authenticator application.",
        twoFactorRecoveryInfoText:
            "Store these recovery codes in a secure password manager. They can be used to recover access to your account if your two-factor authentication device is lost.",
        regenerateRecoveryCodes: "Regenerate Recovery Codes",
        showRecoveryCodes: "Show Recovery Codes",
        passwordUpdated: "Password was updated",
        profileUpdated: "Profile was updated",
    },
    clients: {
        myApartments: "My Apartments",
    },
    taxRates: {
        title: "VAT Rates",
        newRate: "New Tax Rate",
        deleteRate: "Delete Tax Rate",
        deleteRateInfo:
            "VAT rates may only be deleted if they have not been used in any offer. Otherwise deletion leads to an inconsistent system state. If in doubt, do not delete.",
        importantNotice: "Important Notice",
        new: "New VAT Rate",
        description: "Create a new VAT rate",
        name: "Name",
        nameDesc: "Name with percentage sign (e.g. 8.1%)",
        isDefault: "Set as Default",
        standardVat: "Standard VAT Rate",
        value: "Value",
        valueDesc: "Value in percent (use dot without percent sign!)",
        code: "Code",
        deleted: "VAT rate deleted",
        info: "Already used VAT rates must never be edited or deleted! New VAT rates can only be added by creating a new entry. Once a new VAT rate comes into effect, it can be marked as the default rate so that it is automatically pre-selected when creating new offers.",
    },
    deadlines: {
        overdue: "1 or more decisions overdue.",
        nearing: "1 or more decisions due within {threshold} days.",
        on_track: "1 or more decisions pending, deadline ≥ {threshold} days away.",
        no_due_date: "1 or more decisions pending, but no due date set.",
    },
    errors: {
        title: {
            500: "An error occurred",
            503: "Page not available",
            404: "Page not found",
            403: "This action is not allowed",
        },
        detail: {
            500: "Whoops, something went wrong. Please contact our support.",
            503: "We are currently performing maintenance. We will be back for you shortly.",
            404: "The page you were trying to access no longer exists.",
            403: "You are not allowed to access this page",
        },
        // N1 (Fix-Runde 1): dedicated, short key for inline error banners
        // in modals — `errors.detail.500` is the full error-page copy
        // including the support call-to-action, not meant for a toast/banner.
        unexpected: "Something went wrong. Please try again.",
    },
    chat: {
        chat: "Chat",
        buyer: "Buyer",
        buyers: "Buyers",
        consultant: "Consultant",
        typeMessage: "Type your message...",
        loadMore: "Load More",
        loading: "Loading...",
        noMedia: "No media shared yet",
        noDocs: "No documents shared yet",
        noLinks: "No links shared yet",
        media: "Media",
        docs: "Docs",
        links: "Links",
        sharedContent: "Shared Content",
        today: "Today",
        yesterday: "Yesterday",
        searchMessages: "Search Messages",
        searchPlaceholder: "Search messages...",
        noSearchResults: "No messages found",
        searchDescription: "Search for messages with keywords or specific topics.",
        messageInfo: "Message Info",
        sent: "Sent",
        seenBy: "Seen By",
        read: "Read",
        seen: "Seen",
        notSeenYet: "Not seen yet",
        waitingParticipants: "Waiting for participants to read this message.",
        searchInChat: "Search in chat...",
        send: "Send",
        sendVoice: "Send Voice",
        chatDisabled: "Chat is currently disabled for this apartment.",
        enableChatToTalk:
            "Enable chat from the options menu to allow communication with buyers.",
        noBuyersAssigned: "No Buyers Assigned",
        noBuyersAssignedDesc:
            "This apartment currently has no buyers assigned. To start a conversation, please add a buyer to this apartment first.",
        goBackToOverview: "Go Back to Overview",
        dropFilesToSend: "Drop files to send",
        releaseToStageFile: "Release to stage file",
        online: "Online",
        offline: "Offline",
        isTyping: "is typing...",
        typing: "typing...",
        searchInChatDesc: "Find text & jump between matches",
        searchWithDate: "Search with Date",
        searchWithDateDesc: "Jump to specific day",
        enableChat: "Enable Chat",
        disableChat: "Disable Chat",
        toggleChatForBuyers: "Toggle chat for buyers",
        unmuteNotifications: "Unmute Notifications",
        muteNotifications: "Mute Notifications",
        toggleChatAlerts: "Toggle chat alerts",
        markAsUnread: "Mark as unread",
        markAsUnreadSubtitle: "Set unread flag for all advisors",
        seeMore: "See more",
        seeLess: "See less",
        edited: "edited",
        jumpToDate: "Jump to date",
        cancel: "Cancel",
        retake: "Retake",
        confirmUpload: "Confirm & Upload",
        chatUpdated: "Chat Updated",
        chatDisabledMsg: "Chat has been disabled for buyers.",
        chatEnabledMsg: "Chat has been enabled for buyers.",
        document: "Document",
        photos: "Photos",
        videos: "Videos",
        camera: "Camera",
        audio: "Audio",
        reply: "Reply",
        react: "React",
        openChat: "Open chat",
        loadingMessages: "Loading messages...",
        noMessagesYet: "No messages yet. Start the conversation.",
        replyingTo: "Replying to",
        editingMessage: "Editing Message",
        goToMessage: "Go to Message",
        captureWebcam: "Capture moment with your webcam",
        you: "You",
        noPreviewAvailable: "No preview available",
        addCaption: "Add a caption...",
        editImage: "Edit Image",
        takePhoto: "Take Photo",
        tryDifferentKeywords: "Try different keywords or dates.",
        sharedInProject: "Shared in project",
    },
    crop: {
        cropYourImage: "Crop Your Image",
        crop: "Crop",
        cropInstructions:
            "Drag and resize the square to select the area you want to keep. The output will preserve high resolution based on your selection.",
        cancel: "Cancel",
        upload: "Upload",
    },
    // Plan vorlage-auf-wohnungen (Task 10)
    templateTransfer: {
        notify: "Notify buyers",
        switchBlocked: "The template can only be switched while the project has no apartments. Change the topics directly in the project template and then apply them to the existing apartments.",
        openTransfer: "Select apartments",
        completedCount: "One completed apartment will not be changed. | {count} completed apartments will not be changed.",
        apartmentCount: "One apartment | {count} apartments",
        noBuilding: "No building",
        tag: {
            sameName: "one same-named topic exists | {count} same-named topics exist",
            individual: "one individual | {count} individual",
            offer: "one accepted offer | {count} accepted offers",
            progress: "one in progress | {count} in progress",
            blocked: "one blocked | {count} blocked",
            deleted: "one deliberately deleted | {count} deliberately deleted",
        },
        decision: {
            apply: "Apply",
            keep: "Later",
            discard: "Don't apply",
        },
        statKeep: "Later",
        statDiscard: "Won't be applied",
        askLater: "Decide later",
        dismiss: "New apartments only",
        onlyNewTitle: "New apartments only?",
        onlyNewText: "Existing apartments stay unchanged. This change can no longer be applied to them later. | Existing apartments stay unchanged. These {count} changes can no longer be applied to them later.",
        changesTitle: "Changes to the template",
        loading: "Loading preview …",
        title: "Apply template to apartments",
        step: "Step {step} of 2",
        stepSelect: "Selection",
        stepPreview: "Preview",
        stepReport: "Report",
        openChanges: "One change has not yet been applied to all existing apartments. | {count} changes have not yet been applied to all existing apartments.",
        openChangesNone: "All existing apartments match the template.",
        transfer: "Apply",
        askTitle: "Update existing apartments?",
        askText: "The template is saved and applies to all new apartments. One change has not yet been applied to existing apartments. | The template is saved and applies to all new apartments. {count} changes have not yet been applied to existing apartments.",
        askOnlyNew: "New apartments only",
        askTransfer: "Select",
        apartments: "Apartments",
        scopeAll: "All open ({count})",
        scopeSelection: "Selection",
        selected: "One apartment selected. | {count} apartments selected.",
        partialHint: "Not every apartment receives every change. The template still applies to all new apartments: newly created apartments receive these changes as well.",
        showPreview: "Show preview",
        back: "Back",
        statApply: "Will be applied",
        statSkipped: "Skipped",
        statConfirm: "Needs confirmation",
        statBlocked: "Blocked",
        nothing: "No open changes",
        completed: "Completed, will not be changed",
        override: "apply anyway",
        warnBuyers: "Buyers see the changes immediately.",
        warnIrreversible: "This cannot be undone.",
        warnOffers: "One apartment has an accepted offer. A changed budget changes the additional costs for the buyer. | {count} apartments have accepted offers. A changed budget changes the additional costs for the buyer.",
        warnInProgress: "In one apartment a topic to be removed is already in progress. | In {count} apartments a topic to be removed is already in progress.",
        retry: "Apply open items again",
        close: "Close",
        kind: {
            add: "New topic",
            remove: "Remove topic",
            attach_set: "Add option list",
            detach_set: "Remove option list",
        },
        field: {
            icon: "Icon",
            budget: "Budget",
            inclusive: "Inclusive budget",
            disable_calculation: "Calculation disabled",
            active: "Active",
            supplier_uuid: "Supplier",
            name: "Name",
            description: "Description",
            sets: "Option list",
        },
        // Staging round 2: one sentence per exception type, detail per apartment, report
        all: "All {count}",
        why: {
            individual: {
                label: "Individual",
                text: "The value was changed by hand in the apartment.",
            },
            sameName: {
                label: "Same name",
                text: "The apartment already has a topic with this name.",
            },
            offer: {
                label: "Accepted offer",
                text: "A new budget changes the buyer's additional costs.",
            },
            progress: {
                label: "In progress",
                text: "Status, supplier and note are lost when the topic is removed.",
            },
            blockedData: {
                label: "Locked",
                text: "Remove order changes, documents and buyer choices first.",
            },
            blockedSelection: {
                label: "Locked",
                text: "Reset the buyer's choice first.",
            },
            translation: {
                label: "Translation missing",
                text: "Apply the name in this language first.",
            },
        },
        detail: {
            ownValue: "own value {value}",
            before: "previously {value}",
            modifications: "1 order change | {count} order changes",
            documents: "1 document | {count} documents",
            selections: "1 buyer choice | {count} buyer choices",
        },
        summary: {
            changes: "One change | {count} changes",
            applied: "applied to one apartment | applied to {count} apartments",
            nothing: "Nothing applied",
            kept: "{count} later",
            discarded: "{count} not applied",
            completed: "1 completed apartment | {count} completed apartments",
            notified: "1 buyer notified. | {count} buyers notified.",
        },
        section: {
            kept: {
                title: "Later",
                text: "Stays in the notice on the template page and can be applied at any time.",
            },
            discarded: {
                title: "Not applied",
                text: "The apartments stay as they are.",
            },
            completed: {
                title: "Completed",
                text: "These apartments are not changed.",
            },
        },
        empty: "empty",
        yes: "yes",
        no: "no",
    },
};
